(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const component = document.currentScript?.closest('layered-slideshow-component') || 
                      document.querySelector('layered-slideshow-component');
    if (!component) return;

    const container = component.querySelector('.layered-slideshow__container');
    if (!container) return;

    // Show click hint and trigger shake on second slide
    const clickHint = component.querySelector('.layered-slideshow__click-hint');
    const secondPanel = component.querySelector('[role="tabpanel"]:nth-child(2)');
    
    if (clickHint && !clickHint.hasAttribute('data-hint-shown')) {
      clickHint.setAttribute('data-hint-active', 'true');
      clickHint.setAttribute('data-hint-shown', 'true');
      
      // Trigger shake on second slide
      if (secondPanel && !secondPanel.hasAttribute('data-hint-shown')) {
        secondPanel.setAttribute('data-hint-shown', 'false');
      }
      
      // Get duration from data attribute or default to 3 seconds
      const hintDuration = parseFloat(clickHint.getAttribute('data-hint-duration') || '3') * 1000;
      
      // Hide hint after specified duration
      setTimeout(() => {
        clickHint.setAttribute('data-hint-active', 'false');
        if (secondPanel) {
          secondPanel.setAttribute('data-hint-shown', 'true');
        }
      }, hintDuration);
    }

    let pulseDisabled = false;
    let interactionHandlers = [];

    // Disable pulse after user interaction
    function disablePulse() {
      if (!pulseDisabled) {
        pulseDisabled = true;
        container.setAttribute('data-pulse-disabled', '');
      }
    }

    // Handle mobile tap state for all cards
    function handleCardInteraction(panel) {
      if (!panel) return;

      const panelContent = panel.querySelector('.layered-slideshow__panel-content');
      if (!panelContent) return;

      const handleStart = (e) => {
        if (e.type === 'touchstart' || e.type === 'mousedown') {
          panel.classList.add('is-active');
          disablePulse();
        }
      };

      const handleEnd = () => {
        panel.classList.remove('is-active');
      };

      const handlers = [
        { el: panel, event: 'touchstart', handler: handleStart, opts: { passive: true } },
        { el: panel, event: 'mousedown', handler: handleStart },
        { el: panel, event: 'touchend', handler: handleEnd, opts: { passive: true } },
        { el: panel, event: 'mouseup', handler: handleEnd },
        { el: panel, event: 'mouseleave', handler: handleEnd },
        { el: panelContent, event: 'focusin', handler: disablePulse, opts: { once: true } }
      ];

      handlers.forEach(({ el, event, handler, opts }) => {
        el.addEventListener(event, handler, opts);
        interactionHandlers.push({ el, event, handler, opts });
      });
    }

    // Set up interaction listeners
    function setupInteractions() {
      // Set up hover/tap effects for all panels
      const allPanels = component.querySelectorAll('[role="tabpanel"]');
      allPanels.forEach(panel => {
        handleCardInteraction(panel);
      });

      // Disable pulse on any interaction with slideshow
      const interactionEvents = ['click', 'touchstart', 'keydown', 'focusin'];
      interactionEvents.forEach(eventType => {
        const handler = (e) => {
          if (e.target.closest('.layered-slideshow__container')) {
            disablePulse();
          }
        };
        container.addEventListener(eventType, handler, { once: true, passive: true });
        interactionHandlers.push({ el: container, event: eventType, handler, opts: { once: true, passive: true } });
      });

      // Disable pulse when hovering (desktop)
      const hoverHandler = () => disablePulse();
      container.addEventListener('mouseenter', hoverHandler, { once: true });
      interactionHandlers.push({ el: container, event: 'mouseenter', handler: hoverHandler, opts: { once: true } });
    }

    // Wait for component to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupInteractions);
    } else {
      // Small delay to ensure component is initialized
      setTimeout(setupInteractions, 50);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
